import React, { Component } from 'react';
import AuthService from '../../utils/AuthService';
import Page from '../Page';
import PageSection from '../PageSection';
import ThankYou from '../ThankYou';

import logo from '../../assets/images/global/seakeeper-logo-only.svg';

class SizingFormPublished extends Component {

	constructor(props) {
		super(props);
		this.report_id = this.props.match.params.report_id;
	}

	render() {
		var title = <span>Thank you for publishing a Seakeeper <br />Sizing Form & Gyro Configuration!</span>,
			message = <span>You can access all your published reports from your <a href="/dashboard">Dashboard</a><br /> or you can view this <a href={"/report/" + this.report_id}>published report</a> now.</span>;

		return (
			<Page pageClass="pp-sizing-form-thank-you-page">
				<ThankYou
					icon={logo}
				 	title={title}
					message={message}
				/>
			</Page>
		);
	}
}

export default SizingFormPublished;



// WEBPACK FOOTER //
// ./src/components/pages/SizingFormPublished.js